import { render, staticRenderFns } from "./scratch-card.vue?vue&type=template&id=a29cc8fa&scoped=true&"
import script from "./scratch-card.vue?vue&type=script&lang=js&"
export * from "./scratch-card.vue?vue&type=script&lang=js&"
import style0 from "./scratch-card.vue?vue&type=style&index=0&id=a29cc8fa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a29cc8fa",
  null
  
)

export default component.exports